export default __webpack_public_path__ + "static/media/rakib resume.a12e7414.pdf";